module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-076a626224546eba27e873ef1ccc995c.webp";